<template>
  <ImportSourceCard
    :import-source="importSource"
    :tooltip="{
      text: 'import studies from custom source',
      url: '/docs/reviews.html#custom-database-and-other-sources',
    }"
    @import-source-removed="emit('importSourceRemoved')"
  />
</template>
<script setup lang="ts">
import { ImportSource } from '@core/domain/models/import-source.model'
import ImportSourceCard from '../../Components/ImportSourceCard.vue'

const emit = defineEmits<(e: 'importSourceRemoved') => void>()

defineProps<{
  importSource: ImportSource
  readonly?: boolean
}>()
</script>
